export const Events = {
    "ClientReady": "ClientReady",
    "ConnectionUpdate": "ConnectionUpdate",
    "MessagesUpsert": "MessagesUpsert",
    "QR": "QR",
    "GroupsJoin": "GroupsJoin",
    "UserJoin": "UserJoin",
    "UserLeave": "UserLeave",
    "Poll": "Poll",
    "PollVote": "PollVote",
    "Reactions": "Reactions",
    "Call": "Call"
}